import { Grid, TextField, Typography } from "@material-ui/core";
import { BuildingShippingData } from "../../../graphql/models";
import { PhoneInput } from "../phone_input";

export interface BuildingShippingDataEditorProps {
  value: BuildingShippingData | undefined;
  onChange: (buildingShippingData: BuildingShippingData) => void;
}

export function BuildingShippingDataEditor(
  props: BuildingShippingDataEditorProps
) {
  const { value, onChange } = props;

  const handleFieldChange = (fieldName: string) => (v: any) => {
    console.log(`setting ${fieldName}=`, v);
    onChange({
      ...(value ?? {}),
      [fieldName]: v,
    });
  };

  return (
    <Grid container spacing={3} style={{ width: "100%" }}>
      <Grid item xs={12} sm={6}>
        <Typography variant="caption">
          Nome e cognome / Denominazione
        </Typography>
        <br />
        <TextField
          style={{ width: "100%" }}
          variant="outlined"
          type="string"
          defaultValue={value?.name}
          onBlur={(e) => handleFieldChange("name")(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Typography variant="caption">Indirizzo</Typography>
        <br />
        <TextField
          style={{ width: "100%" }}
          variant="outlined"
          type="string"
          defaultValue={value?.addressLine1}
          onBlur={(e) => handleFieldChange("addressLine1")(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography variant="caption">Numero civico</Typography>
        <br />
        <TextField
          style={{ width: "100%" }}
          variant="outlined"
          type="string"
          defaultValue={value?.streetNumber}
          onBlur={(e) => handleFieldChange("streetNumber")(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography variant="caption">Città</Typography>
        <br />
        <TextField
          style={{ width: "100%" }}
          variant="outlined"
          type="string"
          defaultValue={value?.city}
          onBlur={(e) => handleFieldChange("city")(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography variant="caption">Provincia</Typography>
        <br />
        <TextField
          style={{ width: "100%" }}
          variant="outlined"
          type="string"
          defaultValue={value?.province}
          onBlur={(e) => handleFieldChange("province")(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography variant="caption">Cap</Typography>
        <br />
        <TextField
          style={{ width: "100%" }}
          variant="outlined"
          type="string"
          defaultValue={value?.cap}
          onBlur={(e) => handleFieldChange("cap")(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography variant="caption">Nome compagnia</Typography>
        <br />
        <TextField
          style={{ width: "100%" }}
          variant="outlined"
          type="string"
          defaultValue={value?.companyName}
          onBlur={(e) => handleFieldChange("companyName")(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography variant="caption">Recapito telefonico</Typography>
        <br />
        <PhoneInput
          style={{ width: "100%" }}
          variant="outlined"
          type="string"
          defaultValue={value?.mobileNumber}
          onChange={(e) => handleFieldChange("mobileNumber")(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography variant="caption">Informazioni aggiuntive</Typography>
        <br />
        <TextField
          style={{ width: "100%" }}
          variant="outlined"
          type="string"
          defaultValue={value?.extraInformations}
          onBlur={(e) => handleFieldChange("extraInformations")(e.target.value)}
        />
      </Grid>
    </Grid>
  );
}
